module.exports = __webpack_public_path__ + "img/deliveryService.7a39677d.svg";